import { Store } from "lucide-react";
import { useEffect, useState } from "react";

import BlocoRecolhivel from "./BlocoRecolhivel";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

const OPCOES = [
  { modo: "auto", titulo: "Automático", detalhe: "pela categoria da loja" },
  { modo: "restaurante", titulo: "Comer no Local / Para Viagem", detalhe: "restaurante, lanchonete" },
  { modo: "mercearia", titulo: "Levar agora / Entrega", detalhe: "mercearia, açougue" },
];

/** Balcão: as duas opções que aparecem depois do Finalizar (pedido do dono,
 *  29/09/2026). "Entrega" leva o carrinho para o Novo Pedido do Delivery.
 *  Automático segue a categoria do cadastro da loja (mercearia = Levar agora /
 *  Entrega). O Totem continua sempre com Comer no Local / Para Viagem. */
export default function BalcaoConsumoPreferencias({ toast }) {
  const [cfg, setCfg] = useState(null); // {modo, categoria, efetivo}
  useEffect(() => {
    fetch(`${API_URL}/api/settings/balcao-consumo`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setCfg(d || { modo: "auto", categoria: "restaurante", efetivo: "restaurante" }))
      .catch(() => setCfg({ modo: "auto", categoria: "restaurante", efetivo: "restaurante" }));
  }, []);

  const escolher = async (modo) => {
    if (!cfg || modo === cfg.modo) return;
    const anterior = cfg;
    setCfg({ ...cfg, modo });
    try {
      const r = await fetch(`${API_URL}/api/settings/balcao-consumo`, { method: "PUT", headers: auth(), body: JSON.stringify({ modo }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
      setCfg(d);
      toast({ title: "Balcão atualizado", description: d.efetivo === "mercearia" ? "Depois do Finalizar: Levar agora ou Entrega." : "Depois do Finalizar: Comer no Local ou Para Viagem." });
    } catch (e) {
      setCfg(anterior);
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  const categoria = cfg?.categoria === "mercearia" ? "mercearia" : "restaurante";
  const efetivo = cfg?.efetivo === "mercearia" ? "Levar agora / Entrega" : "Comer no Local / Para Viagem";
  const resumo = !cfg ? "Carregando…" : `${cfg.modo === "auto" ? "Automático" : "Escolhido"}: ${efetivo}`;
  return (
    <BlocoRecolhivel e2e="card-balcao-consumo" icone={Store} titulo="Balcão: como o cliente leva" resumo={resumo} carregando={!cfg}>
      <p className="text-sm text-muted-foreground mb-3">
        As duas opções que aparecem depois do Finalizar no Balcão. Em "Levar agora / Entrega", a Entrega leva os produtos
        para o Novo Pedido do Delivery (cliente, endereço e taxa). O Totem continua com Comer no Local / Para Viagem.
      </p>
      <div className="grid gap-2 sm:grid-cols-3">
        {OPCOES.map((o) => {
          const ativo = cfg?.modo === o.modo;
          return (
            <button key={o.modo} type="button" disabled={!cfg} onClick={() => escolher(o.modo)} data-e2e={`balcao-consumo-${o.modo}`} aria-pressed={ativo}
              className={`text-left rounded-xl border px-3 py-2.5 transition-colors disabled:opacity-50 ${ativo ? "border-primary bg-primary/10" : "hover:bg-muted"}`}>
              <p className="text-sm font-medium">{o.titulo}</p>
              <p className="text-xs text-muted-foreground">
                {o.modo === "auto" ? `pela categoria da loja (${categoria}): ${categoria === "mercearia" ? "Levar agora / Entrega" : "Comer no Local / Para Viagem"}` : o.detalhe}
              </p>
            </button>
          );
        })}
      </div>
    </BlocoRecolhivel>
  );
}
